import { api } from './client'

const reconciliationService = {
  getSettings: () => api.get('/reconciliation/settings'),
  getUnreconciled: (accountId) => api.get(`/reconciliation/accounts/${accountId}/unreconciled`),
  getTransactions: (accountId, params = {}) => api.get(`/reconciliation/accounts/${accountId}/transactions`, params),
  getHistory: (accountId, params = {}) => api.get(`/reconciliation/accounts/${accountId}/history`, params),
}

export default reconciliationService
